<template lang="pug">
.deal-filters.mb-S
  h2.mb-S Filters
  .box__body
    .mb-S(v-for="filter in businessUnit.Filters")
      label {{ filter.name }}
      .checkboxes(v-if="filter.rows")
        .checkbox(v-for="(filterRow, indx) in filter.rows" :key="indx")
          label
            input(
              type="checkbox"
              :name="`Filters[${filter.name}]`"
              :value="filterRow.slug"
              :checked="dealHasFilter(filter.slug, filterRow.slug)"
              @input="event => setDealFilter(filter.slug, filterRow.slug, event.target.checked)"
              )
            span.icon-span
              BriqIcon(name="icon-input-checkbox-icon" :customStyle="{color: 'white'}")
            | {{ filterRow.name }}
            span.optional-marker Optional
</template>

<script>
import Vue from 'vue'

// todo: add disabled prop when saving
export default {
  name: 'DealFilters',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    businessUnit: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dealHasFilter(filterSlug, rowSlug) {
      return this.deal.Filters && this.deal.Filters[filterSlug]?.includes(rowSlug)
    },
    setDealFilter(filterSlug, rowSlug, enable) {
      if (enable && !this.dealHasFilter(filterSlug, rowSlug)) {
        if (!this.deal.Filters) Vue.set(this.deal, 'Filters', { [filterSlug]: [rowSlug] })
        else {
          const targetArray = this.deal.Filters[filterSlug]
          if (targetArray) targetArray.push(rowSlug)
          else Vue.set(this.deal.Filters, filterSlug, [rowSlug])
        }
      }
      if (!enable && this.dealHasFilter(filterSlug, rowSlug)) {
        this.deal.Filters[filterSlug] = this.deal.Filters[filterSlug].filter(n => n !== rowSlug)
      }
    },
  },
}
</script>

<style lang="stylus">
// todo: refactor with BriqCheckbox
.deal-filters
  .checkbox input:checked + .icon-span
    background #00aaff
    border-color #00aaff

  .checkboxes
    background transparent
    padding 7px
    border none

  .checkboxes.disabled
    label
      cursor not-allowed
      opacity .5

    .checkbox input:checked + .icon-span
      background #4e5a6a
      border-color #4e5a6a
</style>
